module.exports = __webpack_public_path__ + "static/media/no-image.c2679478.png";